import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { toast } from 'ngx-sonner';
import { SecurityService } from 'app/services/security.service';
import { LoaderService } from 'app/services/loader.service';

@Component({
  selector: 'app-vinculation-whatsapp',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './vinculation-whatsapp.component.html',
  styleUrl: './vinculation-whatsapp.component.css'
})
export class VinculationWhatsappComponent implements OnInit {
  whatsappData = signal<any | null>(null);

  constructor(
    private securityService: SecurityService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.getWhatsappQr();
  }

  getWhatsappQr(): void {
    this.loaderService.show('Preparando canal de WhatsApp...');

    this.securityService.getVinculationWhatsappQr().subscribe({
      next: (response: any) => {
        if (response?.ok && response?.data) {
          this.whatsappData.set(response.data);
        } else {
          toast.error('No fue posible cargar la información de WhatsApp.');
        }
        this.loaderService.hide();
      },
      error: () => {
        toast.error('No fue posible iniciar la vinculación por WhatsApp.');
        this.loaderService.hide();
      }
    });
  }

  openWhatsapp(): void {
    const url = this.whatsappData()?.whatsappUrl;
    if (!url) {
      toast.error('No hay un enlace disponible para abrir WhatsApp.');
      return;
    }
    window.open(url, '_blank');
  }
}
